import styled from '../../style/styled';

export default styled.View();
